import { LOGGER_SERVICE_BRAID as h } from "@waitroom/models";
import { retryWithBackoff as D, parseJson as E, parseStream as I } from "@waitroom/utils";
import { braid_fetch as G } from "./client.es.js";
import { logger as l } from "./config.es.js";
import { buildQueryString as F } from "./helpers.es.js";
const O = {
  method: "GET",
  shouldReconnect: !0,
  subscribe: !0,
  skipRetryErrorCodes: [404]
}, T = (t) => (i) => typeof i == "object" && (t.includes(i.status) || t.includes(i.code)), W = (t) => {
  var i, a;
  if (typeof t == "object" && (t != null && t.error))
    return Number((a = (i = t == null ? void 0 : t.error) == null ? void 0 : i.details) == null ? void 0 : a.errCode);
}, _ = async (t) => {
  if (!(t != null && t.body)) return;
  const i = typeof t.body == "string" ? t.body : t.body instanceof ReadableStream ? await I(t.body) : void 0;
  return i ? E(i) : void 0;
}, q = {
  _client: G,
  _connections: {},
  _listeners: /* @__PURE__ */ new Set(),
  _emitEvent(t) {
    this._listeners.forEach((i) => i(t));
  },
  updateStatus(t, i) {
    const a = this._connections[t];
    a && (a.state.status = i);
  },
  config: { interceptors: {} },
  addListener(t) {
    return this._listeners.add(t), () => this._listeners.delete(t);
  },
  clearListeners() {
    return this._listeners.clear();
  },
  close: function(t) {
    const i = this._connections[t];
    i && (i.abort.abort(`Close called for ${t}`), this.updateStatus(t, "closed"), this._emitEvent({
      type: "close",
      key: t
    }), this._connections[t] && (this._connections[t].connection = void 0));
  },
  // TODO: try refactoring to reduce complexity and split this up into smaller parts
  fetch: async function(t) {
    const { onError: i, onRetry: a } = this.config.interceptors, e = { ...O, ...t }, n = e.key || e.url || "", v = `${e.baseURL}${e.url}${F(e.params)}`;
    return await new Promise(async (b, c) => {
      var g;
      const B = () => new Promise(async (r, f) => {
        var C, k, R, P, $, x;
        if (!!((C = this._connections[n]) != null && C.connection)) {
          const o = `Connection already exists ${n}`;
          if ((k = l) == null || k.logService(h, 5, o), !e.shouldReconnect) return c(new Error(o));
          this.close(n);
        }
        const u = new AbortController();
        if (e.signal) {
          if (e.signal.aborted)
            return this.close(n), b(void 0);
          e.signal.addEventListener("abort", () => {
            this.close(n);
          });
        }
        const w = this._client(v, {
          ...e,
          signal: u.signal
        });
        this._connections[n] = {
          state: {
            status: "connecting",
            url: v,
            key: n,
            startTime: Date.now(),
            arguments: e
          },
          abort: u,
          connection: w
        };
        let s;
        try {
          s = await w, (R = l) == null || R.logService(
            h,
            5,
            "Connection established",
            !!s.subscribe,
            n
          ), this._connections[n] && (this._connections[n].state.response = s), this.updateStatus(n, "connected"), this._emitEvent({
            type: "connection",
            key: n,
            data: { response: s, args: e }
          });
        } catch (o) {
          return (P = l) == null || P.logService(h, 4, "Error", n, o), u.signal.aborted ? c(o) : (this.updateStatus(n, "reconnecting"), f(o));
        }
        if (s.status && s.status > 399) {
          const o = await _(s), d = {
            code: s.code || s.status,
            data: s == null ? void 0 : s.data,
            success: !1,
            error: o || s
          };
          return ($ = l) == null || $.logService(h, 4, "Error", n, d), a ? f(d) : c(d);
        }
        if (e._retry = !1, t.subscribe !== !1)
          s.subscribe(
            (o) => {
              var d, p, L;
              if (o.body) {
                (d = l) == null || d.logService(h, 5, "Body", n), e._retry = !1;
                const y = E(o.body);
                return this._emitEvent({
                  type: "body",
                  key: n,
                  data: y
                }), (p = e.onFetched) == null || p.call(e, y), y ? b(y) : c(o);
              }
              if (o.patches && ((L = l) == null || L.logService(h, 5, "Patch", n), this._emitEvent({
                type: "patch",
                key: n,
                data: o.patches
              }), e.onPatch)) {
                const y = o.patches.map(
                  (m) => ({
                    op: m.unit,
                    path: m.range,
                    value: m.content ? E(m.content) : void 0
                  })
                );
                e.onPatch(y);
              }
            },
            async (o, d) => {
              var p;
              return this._emitEvent({
                type: "error",
                key: n,
                data: { error: o, wasAborted: d }
              }), d ? (this.updateStatus(n, "closed"), b(void 0)) : ((p = l) == null || p.logService(h, 4, "Error", n, o), e.onError && await e.onError(e, o), this.updateStatus(n, "reconnecting"), f(o));
            }
          );
        else {
          if (!s.body) return c(void 0);
          const o = await _(s);
          return o ? (this._emitEvent({
            type: "body",
            key: n,
            data: o
          }), (x = e.onFetched) == null || x.call(e, o), o ? b(o) : c(s)) : c(void 0);
        }
      });
      try {
        await D(B, {
          // infinite retries
          ...e.retryOptions,
          retries: -1,
          shouldSkip: T(e.skipRetryErrorCodes),
          onRetry: async (r, f) => {
            var u;
            if ((u = l) == null || u.logService(h, 5, `Retry ${f}`, n), !a) return;
            if (!await a(e, r)) return c(r);
          }
        });
      } catch (r) {
        if (typeof r == "object" && r) {
          const u = await _(r.error);
          u && (r.error = u);
        }
        return this.updateStatus(n, "closed"), this._emitEvent({
          type: "error",
          key: n,
          data: r
        }), (g = l) == null || g.report(r), this.close(n), e.onError && await e.onError(e, r), !i || !await i(e, r) ? c(r) : await this.fetch(e);
      }
    });
  }
};
export {
  q as braidService,
  W as getDetailsErrorCode,
  T as isErrorCode
};
